module.exports = __webpack_public_path__ + "img/location.45ea732f.png";